import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { CompanyWithDomain } from "@/hooks/useDomainSelector.types";
import { getSubdomain } from "@/core/utils/helpers";
import { setTelemetryCompany, setTelemetryUser } from "@/core/telemetry";
import type { AuthModel } from "@/core/models/Auth.types";
import type { AuthPayload, ConfigState, StoreState } from "@/store/store.types";

const initialAuth: AuthPayload = {
  avatar: "",
  creationdate: "",
  email: "",
  firstname: "",
  id: 0,
  idpartner: null,
  language: "",
  timezone: "",
  lastlogindate: "",
  lastname: "",
  modificationdate: "",
  phonenumber: "",
  rhid: "",
  role: "",
  sso: true,
  state: "",
  suspenddate: null,
  type: "",
  username: "",
  token: "",
  groups: [],
};

const initialConfig: ConfigState = {
  companyId: undefined,
  companyName: "",
  front: "",
  welcomeMessage: "",
  firstRunMessage: "",
  api_end_point: "",
  token: "",
};

export const useStore = create<StoreState>()(
  devtools((set) => ({
    auth: initialAuth,
    config: initialConfig,
    updateUsername: (username: string) => {
      setTelemetryUser(username);
      set((state) => ({ auth: { ...state.auth, username } }));
    },
    updateUser: (user: AuthModel) =>
      set((state) => ({ auth: { ...state.auth, ...user } })),
    updateApiUrl: (api_end_point: string) =>
      set((state) => ({ config: { ...state.config, api_end_point } })),
    updateConfig: (company: CompanyWithDomain) => {
      setTelemetryCompany(company.id, company.name, company.apiDomain);
      const domain = getSubdomain(
        company.name,
        company.custom,
        company.apiDomain,
      );

      set((state) => ({
        config: {
          ...state.config,
          companyId: company.id,
          companyName: company.name,
          front: domain,
          welcomeMessage: company.welcome_message,
          firstRunMessage: company.first_run_message,
          token: company.token,
        },
      }));
    },
  })),
);
